<div class="main-recover-password-company">  
    <div class="container">
        <div class="left-section">
            <h2>{{ 'companyRecoverPassword.title' | translate }}</h2>
            <form [formGroup]="recoverPasswordForm" class="recover-password-form">
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'companyRecoverPassword.form.email' | translate }}</mat-label>
                    <input matInput type="email" id="email" formControlName="email" required>
                </mat-form-field>

                <div *ngIf="recoverPasswordForm.controls['email'].invalid && recoverPasswordForm.controls['email'].touched" style="color: red;">
                    {{ 'companyRecoverPassword.errors.validEmail' | translate }}
                </div>

                <div *ngIf="errorMessage" class="error-message" style="color: red;">
                    {{ errorMessage }}
                </div>
                <ng-container *ngIf="!isLoading; else loading">
                    <button mat-raised-button color="primary" type="submit" (click)="onSubmit()">
                        {{ 'companyRecoverPassword.form.recoverPassword' | translate }}
                    </button>
                </ng-container>
                <ng-template #loading>
                    <img src="/assets/spinner.gif" [alt]="'companyRecoverPassword.form.loading' | translate" class="loading-gif">
                </ng-template>
            </form>
        </div>
    </div>
</div>